const Footer = () => {
  return (
    <footer class="mt-4 mb-2 flex justify-center text-lg w-full 
    text-teal-800 opacity-70 sm:hidden">
      <div>
        <p>made with ❤️ by Mahdi Nemati</p>
      </div>
    </footer>
  );
};

export default Footer;
